import {
  ILoadDefaultTableValues, ILoadDefaultValue, IUpdateLinkType, IUpdateTableValues,
  IUpdateValue, IUpdateCaptchaResponse, IUpdateValues
} from './interfaces';
import { IFieldValueObject } from '../../interfaces/state/index';
import { ActionTypes } from './constants';

export function updateCaptchaResponse(response: string): IUpdateCaptchaResponse {
    return {
        type: ActionTypes.UPDATE_CAPTCHA_RESPONSE,
        response,
    };
}

export function updateValue(id: string, fieldValue: IFieldValueObject): IUpdateValue {
    return {
        type: ActionTypes.UPDATE_VALUE,
        id,
        fieldValue
    };
}

export function updateValues(fieldValues: {[id: string]: IFieldValueObject}): IUpdateValues {
    return {
        type: ActionTypes.UPDATE_VALUES,
        fieldValues
    };
}

export function loadDefaultValue(fieldValue: IFieldValueObject): ILoadDefaultValue {
    return {
        type: ActionTypes.LOAD_DEFAULT_VALUE,
        fieldValue
    };
}
export function updateTableValues(id: string, tableValues: any): IUpdateTableValues {
    return {
        type: ActionTypes.UPDATE_TABLE_VALUES,
        id,
        tableValues
    };
}
export function loadDefaultTableValues(
        id: string,
        tabId: string,
        required: boolean,
        tableItems: any,
        visible: boolean,
    ): ILoadDefaultTableValues {
    return {
        type: ActionTypes.LOAD_DEFAULT_TABLE_VALUES,
        id,
        tabId,
        required,
        tableItems,
        visible
    };
}
export function updateLinkType(id: string, linkType: string): IUpdateLinkType {
    return {
        type: ActionTypes.UPDATE_LINK_TYPE,
        id,
        linkType
    };
}
